// extracted by mini-css-extract-plugin
export default {"wiebenik":"WieBenIk_wiebenik__kuH60","centeredText":"WieBenIk_centeredText__f0h5u"};